module.exports = __webpack_public_path__ + "static/media/whatsapp.42e38209.svg";